var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mymap',{ref:"myMap",attrs:{"locations":_vm.locations,"hashURL":_vm.$route.params.hash,"hideMarker":true,"height":"100vh"}})}
var staticRenderFns = []

export { render, staticRenderFns }